import Card from '../../../common/card';
import OnboardingDialog from '../../../common/onboarding-dialog';
import { ReactComponent as UserIcon } from '../../../../assets/icons/user-circle.svg';
import { Button } from '@mui/material';
import { Box, Paper, Typography, Alert, Checkbox, FormControlLabel, Divider, Container } from '@mui/material';
import { Info } from '@mui/icons-material';
import { useSplitPayments } from '../../../../store/split-payments';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Routes } from '../../../../config/routes';
import l from '../../../../lang';
import ButtonCustom from '../../../common/__deprecated__/button-custom';

const Resume = () => {
  const history = useHistory();
  const { createSplitPaymentPayload } = useSplitPayments();
  const { step, loading, postCreateSplitPayment, requestSuccess } = useSplitPayments();
  const [infoAgree, setInfoAgree] = useState(false);
  const [collaborationAgree, setCollaborationAgree] = useState(false);
  const [errors, setErrors] = useState<{ infoAgree?: string; collaborationAgree?: string }>({});

  useEffect(() => {
    if (step !== 4) {
      history.push(Routes.SPLIT_PAYMENTS);
    }
  }, []);

  useEffect(() => {
    if (requestSuccess) {
      history.push(Routes.SPLIT_PAYMENTS);
    }
  }, [requestSuccess]);

  const handleSubmit = () => {
    if (!infoAgree) {
      setErrors(prev => ({ ...prev, infoAgree: l('split_payments.creation.resume.required.infoAgree') }));
      return;
    }

    if (!collaborationAgree) {
      setErrors(prev => ({ ...prev, collaborationAgree: l('split_payments.creation.resume.required.collabAgree') }));
      return;
    }

    postCreateSplitPayment();
  };

  return (
    <OnboardingDialog
      dividers={false}
      unpaddingContent
      unpaddingFooter
      fullScreenMobile
      type="md"
      bgColor="#F9FAFB"
      title={`${l('split_payments.title')} - ${l('split_payments.creation.invite')}`}
      body={
        <>
          <div style={{ marginTop: '6em', marginLeft: '1em', display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)' }}>
            <div style={{ gridColumn: '2 / 3' }}>
              {createSplitPaymentPayload && (
                <Card>
                  <div className="transaction_detail__title_section">
                    <UserIcon className="transaction_detail__title_section__icon" />
                    {l('split_payments.creation.resume.title')}
                  </div>
                  <Container maxWidth="lg">
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{
                        mb: 3,
                        color: 'text.secondary',
                        fontWeight: 400,
                      }}
                    >
                      {l('split_payments.creation.resume.review_info')}
                    </Typography>

                    {/* Info Alert */}
                    <Alert
                      severity="info"
                      icon={<Info />}
                      sx={{
                        mb: 3,
                        backgroundColor: 'rgba(25, 118, 210, 0.04)',
                        border: '1px solid rgba(25, 118, 210, 0.12)',
                        '& .MuiAlert-icon': {
                          color: 'info.main',
                        },
                      }}
                    >
                      {l('split_payments.creation.resume.start_date_desc')}
                    </Alert>

                    {/* Main Form Paper */}
                    <Paper
                      elevation={0}
                      sx={{
                        p: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        borderRadius: 2,
                      }}
                    >
                      {/* Form Fields */}
                      <Box sx={{ mb: 4 }}>
                        {/* Name Field */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                          <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary' }}>
                            {l('split_payments.creation.resume.name')}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            {createSplitPaymentPayload.name}
                          </Typography>
                        </Box>
                        <Divider sx={{ mb: 3 }} />

                        {/* Email Field */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                          <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary' }}>
                            {l('split_payments.creation.resume.email')}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            {createSplitPaymentPayload.email}
                          </Typography>
                        </Box>
                        <Divider sx={{ mb: 3 }} />

                        {/* Category Field */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                          <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary' }}>
                            {l('split_payments.creation.resume.category')}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            {createSplitPaymentPayload.collaborationCategory}
                          </Typography>
                        </Box>
                        <Divider sx={{ mb: 3 }} />

                        {/* Commission Field */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                          <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary' }}>
                            {l('split_payments.creation.resume.receive_commissions')}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            {l('common.yes')}
                          </Typography>
                        </Box>
                        <Divider sx={{ mb: 3 }} />

                        {/* Percentage Field */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                          <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.primary' }}>
                            {l('split_payments.creation.resume.commission_percentage')}
                          </Typography>
                          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            {createSplitPaymentPayload.collaboratorCommission.toFixed(2)}%
                          </Typography>
                        </Box>
                      </Box>

                      {/* Checkboxes */}
                      <Box sx={{ mt: 4 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={infoAgree}
                              onChange={() => setInfoAgree(!infoAgree)}
                              sx={{
                                color: errors.infoAgree ? 'red' : 'black',
                                alignSelf: 'flex-start',
                                mt: -1,
                                '& .MuiSvgIcon-root': {
                                  fontSize: 20,
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              sx={{ color: errors.infoAgree ? 'red' : 'text.secondary', lineHeight: 1.5 }}
                            >
                              {l('split_payments.creation.resume.agreeInfo')}
                            </Typography>
                          }
                          sx={{
                            alignItems: 'flex-start',
                            mb: 2,
                            ml: 0,
                            '& .MuiFormControlLabel-label': {
                              ml: 1,
                            },
                          }}
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={collaborationAgree}
                              onChange={() => setCollaborationAgree(!collaborationAgree)}
                              sx={{
                                color: errors.collaborationAgree ? 'red' : 'black',
                                alignSelf: 'flex-start',
                                mt: -1,
                                '& .MuiSvgIcon-root': {
                                  fontSize: 20,
                                },
                              }}
                            />
                          }
                          label={
                            <Typography
                              variant="body2"
                              sx={{ color: errors.collaborationAgree ? 'red' : 'text.secondary', lineHeight: 1.5 }}
                            >
                              {l('split_payments.creation.resume.seller_agree')}
                            </Typography>
                          }
                          sx={{
                            alignItems: 'flex-start',
                            ml: 0,
                            '& .MuiFormControlLabel-label': {
                              ml: 1,
                            },
                          }}
                        />
                      </Box>
                    </Paper>
                  </Container>

                  <div className="split-payments__user-type__buttons">
                    <Button
                      variant="contained"
                      size="large"
                      sx={{ backgroundColor: '#E8E8E8', color: 'black', ':hover': { backgroundColor: '#D0D0D0' } }}
                    >
                      {l('common.cancel')}
                    </Button>
                    <ButtonCustom
                      variant="contained"
                      size="large"
                      text={l('split_payments.creation.resume.send_invitation')}
                      onClick={handleSubmit}
                      loading={loading}
                    />
                  </div>
                </Card>
              )}
            </div>
          </div>
        </>
      }
      menuItems={[
        { title: l('split_payments.creation.menu.introduction'), completed: true, selected: false },
        {
          title: l('split_payments.creation.user_type'),
          subItems: [
            {
              title: l('split_payments.creation.menu.seller_collab'),
              completed: true,
              selected: false,
            },
          ],
        },
        {
          title: l('split_payments.creation.menu.collaboration_info'),
          subItems: [
            {
              title: l('split_payments.creation.menu.collaboration_info'),
              completed: true,
              selected: false,
            },
          ],
        },
        {
          title: l('split_payments.creation.menu.terms_and_conditions'),
          subItems: [
            {
              title: l('split_payments.creation.menu.terms_and_conditions_approve'),
              completed: true,
              selected: false,
            },
            {
              title: l('split_payments.creation.menu.agreement'),
              completed: true,
              selected: true,
            },
          ],
        },
      ]}
    />
  );
};

export default Resume;
